var map = {
	"./adrian-cox.md": 5747,
	"./alex-mason.md": 4936,
	"./alisa-wood.md": 5567,
	"./arthur-wang.md": 9227,
	"./bill-coen.md": 4380,
	"./blair-turnbull.md": 3168,
	"./caleb-white.md": 7244,
	"./chris-elliott.md": 5936,
	"./clayton-hayward.md": 9851,
	"./connie-leung.md": 9329,
	"./constance-hunter.md": 7009,
	"./david-rice.md": 5471,
	"./eddie-listorti.md": 980,
	"./elizabeth-lewis.md": 3718,
	"./fernando-morillo.md": 2970,
	"./greg-elliott.md": 2356,
	"./jack-inglis.md": 3091,
	"./karen-silk.md": 540,
	"./kate-frankish.md": 7475,
	"./kay-swinburne.md": 9238,
	"./martin-muller.md": 4403,
	"./matthew-allen.md": 211,
	"./nadine-chakar.md": 1044,
	"./nick-wilde.md": 1432,
	"./paramjit-matharu.md": 9474,
	"./sanjay-rishi.md": 1683,
	"./santokh-birk.md": 1374,
	"./sheri-hinish.md": 9374,
	"./stavros-ioannou.md": 9179,
	"./stuart-spencer.md": 1585,
	"./suni-harford.md": 1409,
	"./vijay-oddiraju.md": 625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;